export enum HomeIndexBoxType {
    VirtualClass = 0,
    Activity = 1,
    Grade = 2,
    Message = 3,
    Forum = 4,
    Announcement = 5,
    Exam = 6,
    Assignment = 7,
    Survey = 8
}